<template>

    <section class="w-100 h-100">

            <!-- Loading -->
            <loading/>
    
            <!-- Contact List -->
            <template v-if="Object.values(alldata).length > 0">
    
                <div class="d-flex flex-row justify-content-between order-1">
                    <h2 class="order-1">Contact List</h2>
                    <strong class="order-2">Os dados serão automaticamente removidos em {{ rgpddatelimit.replace('day', 'dias') }} a contar da data de criação do contato, de acordo com as normas vigentes do RGPD.</strong>
                </div>
                
                <!-- Contact List Render -->
                <table-element :classname="['table-striped', 'order-2', 'my-3']">
    
                    <!-- THead -->
                    <template #thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Mensagem</th>
                            <th scope="col">Assunto</th>
                            <th scope="col">Respondido</th>
                            <th scope="col">Respondido por</th>
                            <th scope="col">Created</th>
                            <th scope="col">Updated</th>
                            <!-- <th scope="col">SoftDelete</th> -->
                            <th scope="col">Actions</th>
                        </tr>
                    </template>
    
                    <!-- Tbody -->
                    <template #tbody>
    
                        <tr v-for="(value, index) in alldata" :key="value.id" :data-referid="index" :data-contactid="value.id">
                            <th scope="row">{{ value.id }}</th>
                            <td>{{ value.firstname }} {{ value.lastname }}</td>
                            <td>{{ value.email }}</td>
                            <td>{{ resumeMessage(value.message, 15, 2) }}</td>
                            <td>{{ value.subject }}</td>
                            <td>{{ value.response }}</td>
                            <td>{{ value.name === null ? '' : value.name }}</td>
                            <td>{{ value.created_at }}</td>
                            <td>{{ value.updated_at !== null ? value.updated_at : '' }}</td>
                            <td>{{ value.deleted_at !== null ? value.deleted_at : '' }}</td>
                            <td class="d-flex flex-row justify-content-between">
                                <button class="btn btn-primary" @click="showModal($event)" data-action="2">Responder</button>
                                
                                <!--
                                <template v-if="value.deleted_at === null">
                                    <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'softdelete')" data-action="3">Delete</button>
                                </template>
                                
                                <template v-else>
                                    <button class="btn btn-info" type="button" @click="buttonsAction($event, 'restore')" data-action="4">Restore</button>
                                </template> -->
                                
                                <div v-if="parseInt(userrule) === 1">
                                    <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'remove')" data-action="5">Remove</button>
                                </div>
    
                            </td>
                        </tr>
    
                    </template>
    
                </table-element>
    
            </template>
    
            <template v-else>
    
                <span>Nenhum contato foi feito pelo website</span>
    
            </template>

            <!-- Modal for Form Update -->
            <modal
                title="Send Response"
                classname="formsendresponse"
            >

                <template #modalcontent>

                    <div class="d-flex flex-column">

                        <div class="my-1 order-1 d-flex flex-column">

                            <h3 class="order-1">Mensagem a responder:</h3>

                            <p class="order-2" style="background-color: #e8e8e8;padding: 1%;">{{ emailoldmessage }}</p>

                        </div>

                        <!-- Email Structure -->
                        <span class="my-3 order-2">
                            <strong style="padding-right: 1rem;">Para:</strong>{{ emailto }}</span>
                        <span class="mt-1 order-3 d-flex flex-column">
                            <small class="order-1">Favor separar os emails por vírgula</small>
                            <div class="d-flex flex-row justify-content-between order-2">
                                <strong class="order-1" style="padding-right: 1rem;">CC:</strong>
                                <input type="text" @focusin="inputValidation($event, 'emailcc')" @focusout="inputValidation($event, 'emailcc')"  v-model="emailcc" id="emailcc" class="emailcc pr-2 order-2" style="width:90%;" />
                            </div>
                        </span>
                        <span class="my-3 order-4">
                            <strong style="padding-right: 1rem;">Assunto:</strong>
                            <input type="text" v-model="emailsubject" id="emailsubject" class="emailsubject pr-2" style="width:82.5%;" />
                        </span>
                        <div class="order-4 my-3">

                            <label for="emailnewmessage" class="form-label">Mensagem:</label>
                            <textarea class="form-control emailnewmessage" @focusin="inputValidation($event, 'emailnewmessage')" @focusout="inputValidation($event, 'emailnewmessage')"  v-model="emailnewmessage" maxlength="2000" id="emailnewmessage" rows="3" aria-describedby="Message to email response" required></textarea>

                        </div>

                        <button class="btn btn-primary order-5" @click="buttonsAction($event, 'response')" data-action="3" :disabled="disabled">Enviar</button>

                    </div>

                </template>

            </modal>   
            
            <!-- Response Messages -->
            <div class="order-3 responsebasemessage" ref="responsebasemessage">
    
                <list-message/>
    
            </div>

    </section>

</template>
<script>

import fetchData from './../../fetchData.js';
import validation from './../../inputValidation.js';
import ListMessage from './../elements/ListMessageElement.vue';
import Loading from './../elements/LoadingElement.vue';
import Table from './../elements/TableElement.vue';
import Modal from './../elements/ModalElement.vue';

//Set Use Strict
"use strict";

export default{
    name: 'ContactsComponent',
    props:{

        csrftolken:{
            type: String,
            required: true
        },
        allcontacts:{
            type: String,
            required: true
        },
        userrule:{
            type: String,
            required: true
        },
        contactsresponse:{
            type: String,
            required: true
        },
        contactsoftdelete:{
            type: String,
            required: true
        },
        contactrestore:{
            type: String,
            required: true
        },
        contactdelete:{
            type: String,
            required: true
        },
        rgpddatelimit:{
            type: String,
            required: true
        }

    },
    data: () => {

        return{

            disabled: true,
            activeclass: 'd-flex',
            alldata: {},
            formaction: "",
            emailto: '',
            emailsubject: '',
            emailoldmessage: '',
            emailcc: '',
            emailnewmessage: '',
            contactid: '',
            buttonsaction: {},
            fullname: '',
            listidinputs: []

        }

    },
    created(){

        //Set All contacts
        this.alldata = JSON.parse(this.allcontacts);


    },
    mounted(){



    },
    methods:{

        showModal(element){

            //Get Index from List
            let parentReferId = element.currentTarget.parentElement.parentElement.getAttribute('data-referid');

            //Get Values from List
            let currentItem = Object.values(this.alldata).find((value, index) => index === parseInt(parentReferId));

            //Set Data for sendmail
            this.contactid = currentItem.id;
            this.emailto = currentItem.email;
            this.emailsubject = "RE: " + currentItem.subject;
            this.emailoldmessage = currentItem.message;
            this.fullname = currentItem.firstname + ' ' + currentItem.lastname;

            //Show Modal
            $(".formsendresponse").modal("show");

            return;

        },
        hideModal(){

            //Hide Modal
            $(".formsendresponse").modal("hide");

        },
        inputValidationMethod(validationtype, inputvalue, inputid = ''){

            //Instance Validation
            let inputValidation = new validation(validationtype, '', '');

            //Validation Method
            let validInput;

            //Set Method
            switch(validationtype)
            {
                //Input Validation only for numbers
                case 2:
                    validInput = inputValidation.validNameCases(validationtype, inputvalue);
                
                break;

                //Input Validation All Types of data
                case 4:
                    validInput = inputValidation.validNameCases(validationtype, inputvalue);
                break;

                //Email Validation
                case 7:

                    let emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
                    validInput = emailRegex.test(inputvalue);
                    
                break;
                
                //URL Validation
                case 8:
                    validInput = inputValidation.isValidUrl(inputvalue, inputid);
                break;

            }

            return validInput;

        },
        inputValidation(element, inputid){

            //Check Value
            if(element.currentTarget.value !== ''){

                //Check by inputid
                switch(inputid)
                {

                    //emailnewmessage
                    case 'emailnewmessage':

                        //Check Validation
                        this.disabled = this.inputValidationMethod(4, element.currentTarget.value) === true ? false : true;

                        //Check Error
                        if(this.disabled){

                            //Set Id for Error Generate
                            this.listidinputs.push(inputid)

                            //Generate Error Message
                            this.dynamicErrorMessageGenerate(this.listidinputs);

                            //Clean Variable
                            this.listidinputs = [];

                        }

                    break;

                    //Email CC
                    case 'emailcc':

                        //Verify Value from Input
                        let emailcc = element.currentTarget.value.includes(',') ? element.currentTarget.value.split(",") : element.currentTarget.value;

                        //Check Type
                        if(Array.isArray(emailcc)){

                            //console.log(linkvideo);

                            emailcc.forEach((vallink) => {

                                //console.log(vallink);

                                //Check Value
                                if(!this.inputValidationMethod(7, vallink.trim())){

                                    return this.disabled = true;

                                }else{

                                    return this.disabled = false;

                                }

                            });

                        }else{

                            //Check Validation
                            this.disabled = this.inputValidationMethod(7, element.currentTarget.value) === true ? false : true;

                        }

                        //Check Error
                        if(this.disabled){

                            //Set Id for Error Generate
                            this.listidinputs.push(inputid)

                            //Generate Error Message
                            this.dynamicErrorMessageGenerate(this.listidinputs);

                            //Clean Variable
                            this.listidinputs = [];

                        }

                    break;

                }

                return this.disabled;

            }

            return this.disabled;

        },
        resumeMessage(text, limit, divisor){

            //console.log(text);
            if(text !== undefined){

                let resume = text.length > limit ?
                `${text.substr(0, Math.round(text.length / divisor))}...` : text;

                return resume;

            }

        },
        buttonsAction(element, action){
            
            //Get Current Item Data
            let currentItem = {};

            //Check Action
            if(action !== 'response'){

                //Get Index from Page List
                let parentReferId = action === 'remove' ? 
                element.currentTarget.parentElement.parentElement.parentElement.getAttribute('data-referid') : 
                element.currentTarget.parentElement.parentElement.getAttribute('data-referid');

                //Get Values from List
                currentItem = Object.values(this.alldata).find((value, index) => index === parseInt(parentReferId));

            }

            //Set Formaction
            switch(action)
            {

                case 'softdelete':
                    this.buttonsaction.id = currentItem.id;
                    this.buttonsaction.formaction = 'softdelete';
                break;

                case 'restore':
                    this.buttonsaction.id = currentItem.id;
                    this.buttonsaction.formaction = 'restoresoftdelete';
                break;

                case 'response':

                    //Check Empty Value
                    if(this.emailnewmessage === ""){

                        //Error Message
                        alert("Favor preencher a mensagem");

                        return this.disabled = true;

                    }

                    //Set formaction
                    this.buttonsaction.contactid = this.contactid;
                    
                    //Set formaction
                    this.buttonsaction.formaction = 'response';

                    //Check Email CC
                    let checkEmailCc = this.emailcc.includes(',') ? this.emailcc.split(',') : this.emailcc;

                    //Set Data To Send Mail
                    this.buttonsaction.emailto = this.emailto;
                    this.buttonsaction.emailsubject = this.emailsubject;
                    this.buttonsaction.emailcc = Array.isArray(checkEmailCc) || checkEmailCc !== "" ? checkEmailCc : null;
                    this.buttonsaction.clientname = this.fullname;
                    this.buttonsaction.emailnewmessage = this.emailnewmessage;

                break;

                case 'remove':

                    //Confirm
                    let confirmAction = confirm(`Are you sure do you want to ${action} this contact?`);

                    //Check Confirm
                    if(!confirmAction){

                       return;

                    }

                    this.buttonsaction.id = currentItem.id;
                    this.buttonsaction.formaction = 'delete';
                    
                
                break;

            }

            //Send Data for delete
            return this.sendData(this.buttonsaction.formaction, this.buttonsaction);

        },
        dynamicErrorMessageGenerate(listIdInputs, timeout = 5000){

            //Show Error Messages
            if(listIdInputs.length > 0){

                //console.log(this.listidinputs);

                //Set id for error message
                listIdInputs.forEach((value) => {

                    //Instance Validation
                    let inputValidation = new validation(3, '', '');

                    //Set Uppercase
                    let firstLetter = value.at(0).toUpperCase();
                    let capitalizaValue = value.replace(value.at(0), firstLetter);

                    //Render Erro Message
                    inputValidation.createErrorMessageElement(value, `Please inform the correct format for ${capitalizaValue}`);

                });

                //Clean Variable
                this.listIdInputs = [];

                //console.log(this.listidinputs);

                //Clean Error Message
                setTimeout(function(){

                    //Clean all Error Messages
                    [...document.querySelectorAll('span.errorMessage')].forEach((value) => {

                        //Remove element
                        value.remove();

                    });

                }, timeout);

                //Disabled Submit
                //this.disabled = true;

                return this.listIdInputs;

            }

        },
        dataStructureResponse(responseObject){

            //Get Key and Value
            let entries = Object.entries(responseObject);

            //Response Value

            //Loop response conditional
            for(const [key, value] of entries){

                switch(key)
                {

                    case 'attListData':

                        //Set Data
                        this.alldata = value;

                        //Clean Data
                        this.emailto = '';
                        this.emailsubject = '';
                        this.emailcc = '';
                        this.emailnewmessage = '';
                        this.emailoldmessage = '';
                        this.fullname = '';
                        this.buttonsaction = {};

                        //Close Modal
                        this.hideModal();

                        //Enable BTN
                        this.disabled = false;

                    break;

                    case 'successMessage':
                    case 'errorMessage':
                        
                        //Add active Class
                        this.$refs.responsebasemessage.classList.add(this.activeclass);
                        this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                        //Set Messages List
                        value.forEach((valmessage) => {

                            //Element for append
                            let li = `<li class="list-group item my-1">${valmessage}</li>`;

                            //Append Element
                            $(li).appendTo(this.$refs.responsebasemessage.children);

                        });
                        

                    break;

                }

            }

            //Remove Base Response Message
            this.removeResponseMessages();

            return;

        },
        removeResponseMessages(time = 5000){

            setTimeout(function(){

                //Remove active class
                document.querySelector('.responsebasemessage').classList.remove('d-flex');
                document.querySelector('.responsebasemessage').classList.remove('successmessage');
                document.querySelector('.responsebasemessage').classList.remove('errormessage');

                //Remove children elements
                let ul = document.querySelector('.responsebasemessage').children;

                [...ul[0].children].forEach((valli) => {

                    //Remove Elements
                    valli.remove();

                });

            }, time);

        },
        sendData(formaction, data = null, element = null){

            //Disabled BTN
            this.disabled = true;

            //Active Loading
            document.querySelector('.loadingbase').classList.add('d-flex');

            //Structure Data Form
            let dataForm = {};

            //Set Route
            let method;
            let urlmethod; 

            switch(formaction)
            {

                //Update
                case 'response':

                    method = 'PUT';
                    urlmethod = this.contactsresponse;
                    dataForm = data;

                break;

                //Delete
                case 'delete':

                    method = 'DELETE';
                    urlmethod = this.contactdelete;
                    dataForm = data;

                break;

                //Soft Delete
                case 'softdelete':

                    method = 'PUT';
                    urlmethod = this.contactsoftdelete;
                    dataForm = data;

                break;

                //Restore Soft Delete
                case 'restoresoftdelete':

                    method = 'PUT';
                    urlmethod = this.contactrestore;
                    dataForm = data;

                break;

            }

            //console.log([method, urlmethod]);
            //console.log(Object.keys(dataForm));
            /* console.log(dataForm);
            return;
            */

            //Check Data Form
            if(Object.keys(dataForm).length > 0){

                //Send Data
                let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                //Check Response
                response.then((value) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled BTN
                    this.disabled = false;

                    //Generate a Response
                    return this.dataStructureResponse(value);

                }).catch((error) => {

                    //Show Error Message
                    alert('Ocorreu um Erro e em breve iremos o resolver, agradecemos pela compreensão');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled BTN
                    this.disabled = false;

                    throw new Error(error);

                });

            }else{

                //Send Message
                alert('Por favor apenas enviar dados válidos');

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Enabled BTN
                this.disabled = false;

            }

            return;

        }

    },
    computed:{

        computedAllData(){

            return this.alldata;

        },
        computedEmailTo(){

            return this.emailto;

        },
        computedEmailSubject(){

            return this.emailsubject;

        },
        computedEmailMessage(){

            return this.emailmessage;

        },
        computedEmailCC(){

            return this.emailcc;

        }

    },
    watch:{

        computedAllData(){},
        computedEmailTo(){},
        computedEmailSubject(){},
        computedEmailMessage(){},
        computedEmailCC(){}

    },
    components:{

        listMessage: ListMessage,
        loading: Loading,
        tableElement:Table,
        modal: Modal

    }
    
}

</script>